import React from 'react';
import { Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom';

import InvoiceList from './invoice/InvoiceList';
import InvoiceListNew from './invoicenew/invoiceNewList';
import { useMainFrameDispatch } from '../component/MainUIFrame/MainFrame';
import { ACTION_FORCE_SET_LIGHT_MODE } from '../component/MainUIFrame/constants';
import { getModuleAllowed } from '../permissions/permission-helper';
import EHRWrapper from './ehr/pages/EHRWrapper';
import Jobs from '../component/FhirComponents/template/jobs/jobsList';

const PrintInvoice = React.lazy(() => import('./invoicenew/printInVoice'));
const Faq = React.lazy(() => import('./faq'));
const ERA = React.lazy(() => import('./era'));
const NotFound = React.lazy(() => import('../pages/404/NotFound'));
const Ehr = React.lazy(() => import('./ehr/ehr'));
const Fhir = React.lazy(() => import('./fhirTest'));
const FHIRClaim = React.lazy(() => import('./FHIRClaim/claimsList'));
const FHIRClaimResponse = React.lazy(() => import('./FHIRClaimResponse'));
const LocationList = React.lazy(() => import('./locations/locationsList'));
const LocationView = React.lazy(() => import('./locations/LocationView'));
const DoctorList = React.lazy(() => import('./doctors'));
const PractitionerRole = React.lazy(() => import('./doctors/practitionerRole'));
const OrganizationList = React.lazy(() =>
  import('./organizations/organizationList')
);
const OrganizationView = React.lazy(() =>
  import('./organizations/OrganizationView')
);
const EHRRecordPage = React.lazy(() => import('./ehr/pages/ehrRecordPage'));
const FHIRAddAllergy = React.lazy(() =>
  import('../component/FhirComponents/template/Allergy/fhirAddAllergy')
);
const EditClaims = React.lazy(() => import('./claims/EditClaims'));
const LoginPage = React.lazy(() => import('./auth/login'));
const ResetPage = React.lazy(() => import('./auth/reset'));
const GenAIForms = React.lazy(() => import('./genAIForms/genAIForms'));
const ListAppointments = React.lazy(() =>
  import('../component/FhirComponents/template/Appointments/index')
);
const ScheduleAppointmentPage = React.lazy(() =>
  import(
    '../component/FhirComponents/template/Appointments/scheduleAppointmentPage'
  )
);
const DocumentUpload = React.lazy(() =>
  import('../component/FhirComponents/template/UploadFile/index')
);
const EligibilityCheck = React.lazy(() => import('./eligibilitycheck'));
const RelatedPersonList = React.lazy(() => import('./relatedperson'));
const NewContact = React.lazy(() => import('./contacts/NewContact'));
const PersonView = React.lazy(() =>
  import('../component/FhirComponents/template/RelatedPerson/relatedPersonView')
);
const FHIRRelatedPerson = React.lazy(() =>
  import('../component/FhirComponents/template/RelatedPerson/fhirRelatedPerson')
);
const CLAIMRecordPage = React.lazy(() =>
  import('./FHIRClaim/pages/claimRecordPage')
);

const ClaimResponseRecordPage = React.lazy(() =>
  import('./FHIRClaimResponse/pages/claimRecordPage')
);

const Providers = React.lazy(() => import('./Providers'));
const Dashboard = React.lazy(() => import('./dashBoard/dashboard'));
const DashboardNew = React.lazy(() => import('./dashboard_new'));
const DashBoard = React.lazy(() => import('./dashBoard_New_0.1/dashboard'));
const AddVitals = React.lazy(() =>
  import('../component/FhirComponents/template/Vitals/fhirAddVitals')
);
const AppontmentNew = React.lazy(() =>
  import('../component/FhirComponents/template/appointmentNew/index')
);
const DoctorRecord = React.lazy(() => import('./doctors/DoctorRecord'));
const Practitioner = React.lazy(() => import('./Practitioner'));
const PractitionerRecordPage = React.lazy(() =>
  import('./Practitioner/pages/practitionerRecordPage')
);
const FormBuilder = React.lazy(() => import('./formbuilder/formBuilderList'));
const FormBuilderList = React.lazy(() =>
  import('./formbuilder/formBuilderList')
);
const ReportTemplateList = React.lazy(() =>
  import('./reportTemplate/reportTemplateList')
);
const NewUser = React.lazy(() => import('./account/pages/NewUser'));

const ResourceManagement = React.lazy(() => import('./resourceManagement'));

// account
const Account = React.lazy(() => import('./account/Account'));

// about
const About = React.lazy(() => import('./about/About'));

const TempHome = () => {
  return <Navigate to="/dashboard" replace={true} />;
};

const SignOut = () => {
  return <Navigate to="/login" replace={true} />;
};

const ProtectedRoute = ({ redirectPath = '/login' }) => {
  // debugger;
  // const location = useLocation();
  // const token = localStorage.getItem(`jwtToken`);

  // if (!token) {
  //   // return <Navigate to={redirectPath} replace state={{ from: "signout" }} />;
  // }

  // if (token) {
  //   // const tokenExpTime = jwtDecode(token)?.exp * 1000;
  //   // const currentTime = new Date()?.valueOf();
  //   // if (currentTime > tokenExpTime) {
  //   //   return <Navigate to={redirectPath} replace state={{ from: "signout" }} />;
  //   // }
  // }

  return <Outlet />;
};

const user = { name: 'Siva Palagummi', admin: 'true' };
const Pages = () => {
  return (
    <>
      <Routes>
        <Route exact path="/login" element={<LoginPage />} />
        <Route exact path="/reset" element={<ResetPage />} />
        <Route
          exact
          path="/forms/:formId/patient/:patientId"
          element={<GenAIForms />}
        />
        <Route element={<ProtectedRoute />}>
          <Route path="*" element={<NotFound />} />
          <Route exact path="/" element={<TempHome />} />
          {/* <Route exact path="/dashboard" element={<DashboardNew />} /> */}
          <Route exact path="/dashboard" element={<DashBoard />} />
          <Route exact path="/about" element={<About />} />

          {getModuleAllowed('contacts') && (
            <>
              <Route exact path="/contacts" element={<RelatedPersonList />} />
              <Route
                exact
                path="/contacts/record/:id"
                element={<NewContact />}
              />
              <Route
                exact
                path="/contactsOld/record"
                element={<PersonView />}
              />
              <Route
                exact
                path="/contacts/update"
                element={<FHIRRelatedPerson isEdit={true} />}
              />
            </>
          )}
          {getModuleAllowed('appointments') && (
            <>
              <Route exact path="/appointments" element={<AppontmentNew />} />
              <Route
                exact
                path="/appointments/schedule"
                element={<ScheduleAppointmentPage />}
              />
            </>
          )}
          <Route
            exact
            path="resource-management"
            element={<ResourceManagement />}
          />

          {getModuleAllowed('locations') && (
            <>
              <Route exact path="/locations" element={<LocationList />} />
              <Route
                exact
                path="/location/view/:id"
                element={<LocationView />}
              />
            </>
          )}

          {getModuleAllowed('organizations') && (
            <>
              <Route
                exact
                path="/organizations"
                element={<OrganizationList />}
              />
              <Route
                exact
                path="/organization/view/:id"
                element={<OrganizationView overflow={true} />}
              />
            </>
          )}

          {getModuleAllowed('ehr') && (
            <>
              <Route exact path="/ehr" element={<Ehr />} />
              <Route
                exact
                path="/ehr/record/:id"
                element={<EHRRecordPage isCreate={false} />}
              />
              <Route
                exact
                path="/ehr/doctor"
                element={<DoctorRecord isCreate={false} />}
              />
              <Route
                exact
                path="/ehr/patient/create"
                element={<EHRRecordPage isCreate={true} isEdit={true} />}
              />
              <Route
                exact
                path="/ehr/patient/allergy/create"
                element={<FHIRAddAllergy isCreate={true} />}
              />
              <Route exact path="/ehr/vitals/update" element={<AddVitals />} />
            </>
          )}

          {getModuleAllowed('claim') && (
            <>
              <Route exact path="/claims" element={<FHIRClaimResponse />} />
              <Route exact path="/claims/edit" element={<EditClaims />} />
              <Route exact path="/claims/era" element={<ERA />} />
              <Route
                exact
                path="/claims/record"
                element={<CLAIMRecordPage isCreate={false} />}
              />
              <Route
                exact
                path="/claim/record/:id"
                element={<ClaimResponseRecordPage isCreate={false} />}
              />
              <Route
                exact
                path="/claims/create"
                element={<CLAIMRecordPage isCreate={true} isEdit={true} />}
              />
            </>
          )}

          {getModuleAllowed('practitioners') && (
            <>
              <Route
                exact
                path="/practitionerRoleOld"
                element={<PractitionerRole />}
              />
              <Route exact path="/practitioner" element={<Practitioner />} />
              <Route
                exact
                path="/practitioner/record/:id"
                element={<PractitionerRecordPage isCreate={false} />}
              />
              <Route
                exact
                path="/practitioner/create"
                element={
                  <PractitionerRecordPage isCreate={true} isEdit={true} />
                }
              />
            </>
          )}

          {getModuleAllowed('form') && (
            <>
              <Route exact path="/forms" element={<FormBuilderList />} />
            </>
          )}

          {getModuleAllowed('invoice') && (
            <>
              <Route exact path="/invoice" element={<InvoiceListNew />} />
              <Route exact path="/invoice/view" element={<PrintInvoice />} />
              <Route exact path="/invoice/add" element={<PrintInvoice />} />
            </>
          )}

          {getModuleAllowed('reportsTemplates') && (
            <>
              <Route
                exact
                path="/report-templates"
                element={<ReportTemplateList />}
              />
            </>
          )}

          {getModuleAllowed('accounts') && (
            <>
              <Route exact path="/account" element={<Account />} />
              <Route exact path="/user/add" element={<NewUser />} />
              <Route exact path="/user/edit/:id" element={<NewUser />} />
            </>
          )}

          {getModuleAllowed('export') && (
            <>
              <Route exact path="/exports" element={<Jobs />} />
            </>
          )}

          {/* <Route exact path="/faqs" element={<Faq />} /> */}
          <Route exact path="/fhir" element={<Fhir />} />
          {/* <Route exact path="/checkeligibility" element={<EligibilityCheck />} /> */}
          {/* <Route exact path="/claimResponse" element={<FHIRClaim />} /> */}
          {/* <Route exact path="/doctors" element={<DoctorList />} /> */}
          {/* <Route exact path="/providers" element={<Providers />} /> */}
          {/* <Route exact path="/dashboardOld" element={<Dashboard />} /> */}
          {/* <Route exact path="/appointmentsOld" element={<ListAppointments isCreate={true} />} />   */}
          {/* <Route exact path="/docs" element={<DocumentUpload isCreate={true} />} /> */}
          {/* <Route exact path="/invoicenew" element={<InvoiceList />} /> */}
        </Route>
      </Routes>
    </>
  );
};

export default Pages;
